import React, { useMemo } from 'react';
import { CipStatusReportIcon } from '@common-fe/common-fe';

import { ROUTES } from '@/common';
import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core';

import { useFavoriteReportHandler } from '../../hooks';
import { ReportTypeKeys } from '../../report.types';
import ReportCardBase, { ReportCardBaseProps } from '../ReportCardBase';

import { useCIPStatusBriefQuery } from './queries';

interface Props extends ReportCardBaseProps {}
const TEST_ID = 'cip-status-report-card';
const CIPStatusCard: React.FC<Props> = ({ isFavoriteMode }) => {
  const {
    observingOrganization: { type },
  } = useCurrentOrganization();
  const isSystem = useMemo(() => type === OrganizationTypes.system, [type]);

  const { data: percents, title, isLoading } = useCIPStatusBriefQuery();
  const childrenNode = useMemo(() => {
    if (!isSystem && percents) {
      return (
        <ReportCardBase.DescriptionBase
          isLoading={isLoading}
          testId={TEST_ID}
          title={title}
          items={[
            {
              label: 'Pass rate',
              value: percents ? `${percents || 0} Passed` : '',
            },
          ]}
        />
      );
    }
    return null;
  }, [isLoading, isSystem, percents, title]);

  const { isFavorite, handleToggleReportKey } = useFavoriteReportHandler(ReportTypeKeys.CIPStatus);

  return (
    <ReportCardBase
      // isUpdated
      testId={TEST_ID}
      isWideMode={isFavoriteMode}
      isFavorite={isFavorite}
      onChangeFavorite={handleToggleReportKey}
      url={ROUTES.CIP_STATUS_REPORT}
      icon={
        <CipStatusReportIcon
          size={isFavoriteMode ? '50px' : '40px'}
          color={isFavoriteMode ? 'iconAccent' : 'iconDisabled'}
        />
      }
      title="CIP Status"
      description="HSAs require CIP completion to open. 
The CIP Status Report tracks participant progress"
    >
      {childrenNode}
    </ReportCardBase>
  );
};
export default CIPStatusCard;
